 <HistoryUploadDetail headerTextWP="Water Process History Upload Details" detailsType="Water Process" ListURL="WaterProcess/WPHistoryUploadSearch">
